<template>
  <div >

    <div class="md-layout">
    <div class="md-layout-item md-size-100">

      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">Nutricionistas</h4>
          </div>
        </md-card-header>
        <md-card-content>

                <div class="md-layout"   v-if="show_message == 'on' ">
                              <div  class="alert alert-success" style="width: 100%">
                                          {{message_text}}
                              </div>
                </div>
          
        <div  v-if="loading">
                 
                        <md-progress-spinner  :md-diameter="30" md-mode="indeterminate"></md-progress-spinner> {{msg_status}} ..
       
         </div>

         <table class="striped responsive-table">
          <tr>
                  <td>

            
                      <autocomplete search_method="nutricionista" field_value="id" :exclude_itens="items" field_text="nome"
                      show_add=true
                      :onAdd="add_item"></autocomplete>
                  </td>
                  <td style="width: 100px">

                        <md-button class="md-info pull-right"
                                type="button" v-bind:disabled="disableButton"
                                v-on:click="salvar">Salvar</md-button>
                  </td>
              
          </tr>

    </table>

         <table class="striped edit-table"  >
             <thead>
             	<tr>
                                 <th>ID</th>  
                                <th>Nome</th>  
                                <th>E-mail</th>  
                     <th>

                  <md-button v-if="false"
                  class="md-just-icon md-info md-simple"
                  @click.native="add"
                >
                  <md-icon>add</md-icon>
                </md-button>
                     </th>
             	</tr>
             </thead>
             <tbody>
                 <tr v-for="(item, index) in items" :key="index">
                      <td>{{item.id}} </td>
                      <td>{{item.nome}} </td>
                      <td>{{item.email}} </td>
					  
                    
                     <td>
                                 <md-button
                                            class="md-just-icon md-info md-simple"
                                            @click.native="excluir(item, index)"
                                            >
                                            <md-icon>remove_circle</md-icon>
                                 </md-button>
                     </td>

                 </tr>
             </tbody>
             <tfoot >
              <tr v-if="items.length <= 0">
                <td colspan="4">
                  <i>Sem registros</i></td>
              </tr>
               <tr >
                <td colspan="4">
                 
                     <md-button class="md-info pull-right"
                             type="button" v-bind:disabled="disableButton"
                             v-on:click="salvar">Salvar</md-button>
                 </td>
              </tr>
             </tfoot>

         </table>


        </md-card-content>
      </md-card>


  </div>
  </div>

  </div>



</template>

<script>

import service from "../../../services/NutricionistaService";
import autocomplete from '../../../components/Rend/autocomplete';


    export default {
        props: ['tabela', 'id_pai', 'onSave', 'onPreSave'],
        components: {
               autocomplete
        },
        data: function() {
            return {
                
              items: [],

              ids_excluir: [],

              action: "list",
              id: "",
              table: null,
              filtro_titulo: "",
              filtro_status: "",

              show_new_button: true,

              

              loading: false, 
              msg_status: "Carregando",
              disableButton: false,
			  
			  
              item_add:null, 

              message_text:"",
              show_message:"off",

              button_new_text: "" //<i class=\"fa fa-file\" ></i> NOVA POST"
            }
        },
        methods: {
            
            getIDItem(nome, index){
                return "contatos_"+nome+"_L" +index.toString();
            },
            change_data_item(id_campo, value){

                   if ( id_campo.indexOf("data") > -1 ){

                        var ar = id_campo.split("_L");
                        var index = ar[1];
                        var item = this.items[ parseInt(index) ];
                        
                        var arcampo = id_campo.split("contatos_");
                        var arcampo2 = arcampo[1].split("_L");
                        var nome_campo = arcampo2[0];

                        console.log("Localizado nome do campo " + nome_campo + " e data"+ value);
                        
                        item[nome_campo] = value;
                        Vue.set(this.items, parseInt(index), item);
                        console.log("Consegui alterar para o indice : " + index );
                    }



            },
            onSelectAutoComplete(item){

                     this.item_add = item;

            },
            change_value(event){

              this.change_data_item( event.target.id, event.target.value );

        
            },
            excluir(item, index){

              console.log("Excluir? ");

                if (item.id != null &&  item.id != ""){

                     this.ids_excluir.unshift(  item.id );
                }

                this.items.splice(index, 1);
            },
            datepicker_return(dateText, inst){
                         console.log("Cheguei aqui? ");
            },
            salvar(){
                      var self = this;
                      var hd_json = JSON.stringify(this.items);
                      var ids_delete_json =  JSON.stringify(this.ids_excluir);

                      if ( this.onPreSave != null  && this.onPreSave != undefined ){
                            this.onPreSave(  this.tabela,  this.id_pai );
                      }

                      
                      self.disableButton = true;
                      self.loading = true;
                      self.msg_status = "Salvando";

                      service.salvarGrid(hd_json, ids_delete_json, this.tabela, this.id_pai ).then( 
                            function (response)
                            {

                              
                                 self.disableButton = false;
                                 self.loading = false;
                                 self.msg_status = "Carregando";      
                                 self.show_message = "on";
                                 self.message_text = "Contatos salvos com sucesso!";
								 
                                             if (self.onSave != null && self.onSave != undefined ){
                                                   
                                                    self.onSave(  self.tabela,  self.id_pai , self.items );
                                             }                     
                            }
                       ).catch(function(error){
                          console.log( JSON.parse(  JSON.stringify(error ) ));
                      });
            },
            add_item( item_add ){

              if ( item_add != null ){                   
                   this.items.unshift( JSON.parse(  JSON.stringify(  item_add )) );
              }
                  //this.items.push( this.getArrayItem() );
            },
            add(){

              if ( this.item_add != null ){

                   
                   this.items.unshift( JSON.parse(  JSON.stringify(  this.item_add )) );
                   this.item_add = null;
              }
                  //this.items.push( this.getArrayItem() );
            },
            add_old(){
                  this.items.push( this.getArrayItem() );
            },
            loadData(){
              var self  = this;

                var url =  "nutricionista_gridcad"; // 
                this.disableButton = true;
                this.loading = true;
                this.msg_status = "Carregando";

                var data = { }

                service.getListByParent( this.tabela, this.id_pai ).then(function (response){


                                 self.items = response.data.data;
                                 console.log( self.items );
                                 
                                 self.disableButton = false;
                                 self.loading = false;
                                 self.msg_status = "Carregando";

                                
                                 
                }).catch(function(error){
                    console.log( JSON.parse(  JSON.stringify(error)));
                });
                
            },
            getArrayItem(){
                      var data = service.getModel(); 

                        if ( this.tabela != null ){
                               data["tabela"] = this.tabela;
                         } 
                        if ( this.id_pai != null ){
                               data["id_pai"] = this.id_pai;

                        } 


                      return data;
            }
            
        },
        mounted() {

                let self = this;

                 if ( this.tabela == null || this.id_pai == null ){
                     return;
                 }

                this.loadData();
             
  
        }
    }
    </script>